import { useState } from 'react';
import { buzzItems } from '@/mocks/home';
import SectionHeading from './SectionHeading';

const avatarTone = {
  primary: 'bg-primary-500 text-background-50',
  accent: 'bg-accent-500 text-foreground-950',
  secondary: 'bg-secondary-500 text-background-50',
};

export default function BuzzSection() {
  const [liked, setLiked] = useState<number[]>([]);

  const toggleLike = (id: number) => {
    setLiked((prev) => (prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]));
  };

  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          tone="secondary"
          eyebrow="话题热议"
          title="网友都在怎么讨论这些事件"
          desc="挑出有信息量的讨论，只保留对理解事件有帮助的观点，评论区不做情绪站队。"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {buzzItems.map((item) => {
            const isLiked = liked.includes(item.id);
            return (
              <article key={item.id} className="flex flex-col rounded-lg border border-background-300 bg-background-50 p-5">
                <div className="flex items-center gap-3">
                  <span className={`flex h-10 w-10 items-center justify-center rounded-full font-heading text-sm font-bold ${avatarTone[item.avatarColor]}`}>
                    {item.user.slice(0, 1)}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-semibold text-foreground-950">{item.user}</p>
                    <p className="text-xs text-foreground-500">{item.time}</p>
                  </div>
                  <span className="shrink-0 rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-semibold text-secondary-800">
                    {item.topic}
                  </span>
                </div>

                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{item.content}</p>

                <div className="mt-4 flex items-center gap-4 border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <button
                    type="button"
                    onClick={() => toggleLike(item.id)}
                    className={`flex cursor-pointer items-center gap-1 whitespace-nowrap transition-colors ${
                      isLiked ? 'text-primary-600' : 'hover:text-primary-600'
                    }`}
                  >
                    <i className={isLiked ? 'ri-heart-fill text-base' : 'ri-heart-line text-base'} />
                    {item.likes}
                  </button>
                  <button type="button" className="flex cursor-pointer items-center gap-1 whitespace-nowrap hover:text-primary-600">
                    <i className="ri-chat-1-line text-base" />
                    展开讨论
                  </button>
                  <button type="button" className="ml-auto flex cursor-pointer items-center gap-1 whitespace-nowrap hover:text-primary-600">
                    <i className="ri-share-forward-line text-base" />
                    分享
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}